import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const Linha = styled.div`
  display: flex;
  flex: 1;

  flex-direction: row;
  align-items: start;
  justify-content: center;

  padding: 0 ${({ theme }) => theme.spacing[9]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const LojasAplicativos = styled.div`
  display: flex;
  flex-direction: row;

  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const LinhaImagens = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ImagemAplicativo = styled.div`
  display: flex;
  position: relative;

  border-radius: ${({ theme }) => theme.radius[4]}px;

  height: 39px;
  width: 128px;
`;

export const Coluna = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  padding: 0 ${({ theme }) => theme.spacing[6]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ColunaRedesSociais = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ColunaLogos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;
